var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNpRocketTangramRestart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100pt",
    height: "100pt",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m71.301 81.801-4.3008-6.4023c-6 5.3984-14 8.6992-22.699 8.6992-18.801 0-34.102-15.301-34.102-34.102 0-18.801 15.301-34.102 34.102-34.102 18.602 0 33.699 14.898 34.102 33.398l-11.504 0.007812 15.301 24.398 15.301-24.398h-11.5c-0.39844-22.699-19-41.102-41.801-41.102-23 0-41.699 18.801-41.699 41.801s18.699 41.801 41.801 41.801c10.301 0 19.699-3.8008 27-10z"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: "50pt",
    height: "50pt",
    x: 10,
    y: 15,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m60.73 60.879v-43.539l-10.879-10.879-10.891 10.879v43.539l-10.883 10.891v21.77l10.883-10.879 10.891-10.891 10.879 10.891 10.891 10.879v-21.77z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpRocketTangramRestart);
export default __webpack_public_path__ + "static/media/np_rocket-tangram-restart.b6957eac4f336739991660cb99b93634.svg";
export { ForwardRef as ReactComponent };